<template>
  <el-select
    v-model="value"
    @change="change"
    filterable
    remote
    clearable
    :loading="loading"
    :multiple="multiple"
    :remote-method="getChannelSlotName"

    placeholder="渠道广告位">
    <el-option
      v-for="item in slotNameOptions"
      :key="item.slotId"
      :label="item.slotName"
      :value="item.slotId"/>
  </el-select>
</template>

<script>
import { getChannelSlotName } from '@/api/select'
import { hot } from '@/api/hot'

export default {
  props: {
    modelValue: [String, Number],
    channelId: {
      type: Number,
      default: undefined
    },
    deleted: {
      type: Number,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      slotNameOptions: [],
      loading: false,
      value: undefined
    }
  },
  watch: {
    channelId (newVal,oldVal) {
      if (this.multiple) {
        this.value = []
        this.change([])
      } else {
        this.value = ''
        this.change('')
      }
      if(newVal !== undefined){
        this.getChannelSlotName()
      }
    }
  },
  methods: {
    getChannelSlotName (query) {
      this.loading = true
      getChannelSlotName({ channelId: this.channelId, deleted: this.deleted, searchKey: query }).then(res => {
        if (res.code === 200) {
          this.slotNameOptions = res.data
          this.slotNameOptions.map((item) => {
            item.slotName = item.slotName + '-' + item.slotId
          })
        }
      })
      this.loading = false
    },
    change (item) {
      const data = {
        maker: 'slotInfoOnThe',
        onTheOrderId: item
      }
      if (item && !this.multiple) {
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    }
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>

<style scoped>

</style>
